export const categories = {
	navTitle: "Categorías",
	title: "Categorías",
	subtitle: "Ver, reordenar, crear y editar tus categorías de productos.",
	searchPlaceholder: "Categoría, subcategoría o producto",
	addCategoryBtn: "Agregar categoría",
	amountOfCategories_one: "{{count}} categoría",
	amountOfCategories_other: "{{count}} categorías",
	filterByBtn: "Filtrar orden",
	categoryEmptyState: {
		title: "No se encontró categoría",
		description: "Aún no hay categorías registradas.",
	},
	subcategories_one: "{{count}} Subcategoría",
	subcategories_other: "{{count}} Subcategorías",
	products_one: "{{count}} Producto",
	products_other: "{{count}} Productos",
	chartAccountName: "Plan de Cuentas",
	noCategoryDescription: "Aún no hay descripción para esta categoría.",
	addSubcategoryBtn: "Agregar subcategoría en {{category}}",
	addProductBtn: "Agregar producto en {{category}}",
	dialog: {
		create: {
			title: "Agregar categoría",
			save: "Guardar categoría",
		},
		createSubcategory: {
			title: "Agregar subcategoría",
			save: "Guardar subcategoría",
		},
		edit: {
			title: "Editar categoría",
			delete: "Eliminar categoría",
			deleteTooltip: "Esta categoría tiene productos asociados",
			save: "Guardar cambios",
		},
		form: {
			name: {
				label: "Nombre",
				placeholder: "Establecer nombre de categoría",
				requiredName: "El nombre es requerido",
			},
			priority: {
				label: "Posición de prioridad",
				tooltip: "Orden en el que aparecerá entre las categorías.",
				placeholder: "Establecer posición o reordenar en la lista después",
				requiredPriority: "El nivel de prioridad es requerido",
			},
			printOrder: {
				label: "Fase de entrega",
				tooltip:
					"Categoría para fases automáticas de curso.<br>El operador podrá reordenar en POS si es necesario.",
				placeholder: "Asignar fase automática",
				requiredPrintOrder: "La fase de categoría es requerida",
				invalidPrintOrder: "Fase de categoría inválida",
			},
			chartAccount: {
				label: "Plan de cuentas",
				tooltip: "El plan de cuentas define la cuenta contable de la categoría.",
				placeholder: "Seleccionar",
			},
			description: {
				label: "Descripción de categoría",
				placeholder: "Describir categoría",
			},
		},
	},
	modal: {
		delete: {
			title: "¿Quieres eliminar la categoría?",
			description:
				"Al confirmar, la categoría será eliminada y la acción no se puede deshacer.",
			confirm: "Eliminar categoría",
			cancel: "Cancelar",
		},
	},
	inputImage: {
		addImage: "Agregar imagen",
		infoTypeAndSize: "Tipo de archivo {{type}} hasta {{size}}MB",
		infoOnlyType: "Tipo de archivo {{type}}",
		infoOnlyMaxSize: "{{size}}MB",
	},
	productToOrg: {
		nameLabel: "Nombre",
		kindLabel: "Tipo de producto",
		kindPlaceholder: "Seleccione el tipo de producto",
		hasAlcoholLabel: "Contiene alcohol",
		createDialogTitle: "Crear producto",
		editDialogTitle: "Editar producto",
		createProductBtn: "Crear producto",
		editProductBtn: "Editar producto",
	},
};
